import { render, staticRenderFns } from "./ModalExclusaoFiltro.vue?vue&type=template&id=2430520a&scoped=true&"
import script from "./ModalExclusaoFiltro.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoFiltro.vue?vue&type=script&lang=js&"
import style0 from "./ModalExclusaoFiltro.vue?vue&type=style&index=0&id=2430520a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2430520a",
  null
  
)

export default component.exports